import { createRoot } from "react-dom/client";
import { createElement, StrictMode } from "react";
import { Provider } from "react-redux";
import store from "../store";

// Util function to render a react component in a DOM element
export const renderReactComponentInElement = (reactComponent, elementID, props={}, reactRoot=undefined) => {
    let root = reactRoot
    if (reactRoot === undefined) {
        root = createRoot(document.getElementById(elementID))
    }
    root.render(
        createElement(StrictMode, null, createElement(Provider, { store }, createElement(reactComponent, props)))
    );
    return root;
}


// util function to use selectors outside of React.
// it provides a snapshot of that state, doesn't subscribe anything to updates
export function staticSelect(selector, state=store.getState()) {
    return selector(state);
}